export default __webpack_public_path__ + "static/window-1-663bfddb6e12564b58d3a327a4dc5a6e.jpg";